class Presenter {
    constructor(template) {
        this.template = template;
        this.viewModel = new this.template();
        ;
    }
    reset() {
        this.viewModel = new this.template();
        ;
    }
    initIfNotPresent() {
        if (!this.viewModel) {
            this.reset();
        }
    }
}

class BaseEntity {
}

/*
 * Public API Surface of datahive-architecture
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BaseEntity, Presenter };
